"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourHomeAwayFromHome() {
  const {
    ref: leftColRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightColRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="your-home-away-from-home" className="bg-background py-24 md:py-32 overflow-hidden relative">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div ref={leftColRef} className={`lg:col-span-7 flex flex-col items-start space-y-8 transition-all duration-[800ms] ease-[cubic-bezier(0.16,1,0.3,1)] ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[30px]"}`}>
            {}
            <span className="font-mono text-xs font-semibold tracking-[0.15em] uppercase text-muted-foreground">
              Your Home Away From Home
            </span>

            {}
            <h1 className="font-sans text-[clamp(2.5rem,8vw,5.5rem)] tracking-tight leading-[1.1] text-foreground">
              <span className="italic font-light">Praise</span>{" "}
              <span className="font-bold">Space</span>
            </h1>

            {}
            <p className="font-sans text-xl font-light tracking-[0.01em] leading-relaxed text-foreground/80 max-w-2xl">
              We provide high-quality serviced accommodation and Airbnb stays for business travelers, contractors, families, and leisure guests. Our fully furnished properties offer the comfort of home with convenience, featuring modern amenities, flexible booking options, and exceptional guest support.
            </p>

            {}
            <Button asChild className="bg-primary text-primary-foreground hover:bg-secondary hover:text-secondary-foreground rounded-sm py-6 px-8 h-auto text-base font-medium transition-colors duration-400 mt-4">
              <Link to="/GuestExperiencePage">
                Discover Our Spaces
              </Link>
            </Button>
          </div>

          {}
          <div ref={rightColRef} className={`lg:col-span-5 relative mt-8 lg:mt-0 transition-all duration-[800ms] ease-[cubic-bezier(0.16,1,0.3,1)] delay-100 ${isRightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[30px]"}`}>
            {}
            <div className="absolute -top-5 -right-5 w-6 h-6 border-t-[1.5px] border-r-[1.5px] border-secondary z-10 pointer-events-none" aria-hidden="true" />
            
            {}
            <div className="absolute -bottom-5 -left-5 w-6 h-6 border-b-[1.5px] border-l-[1.5px] border-secondary z-10 pointer-events-none" aria-hidden="true" />

            {}
            <div className="relative aspect-[3/4] w-full bg-muted overflow-hidden group">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/hero_architectural_interior.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/hero_architectural_interior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1692125/img/hero_architectural_interior.png-wvc-sizes" alt="High-quality serviced accommodation interior" className="object-cover w-full h-full transition-transform duration-[1200ms] ease-out group-hover:scale-105" loading="lazy" decoding="async" />
              {}
              <div className="absolute inset-0 bg-foreground/5 mix-blend-multiply pointer-events-none" aria-hidden="true" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}